import { Checkbox, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  UpdateInvoiceFields,
  useInvoiceReviewContext,
  useInvoiceReviewStateDispatch,
  useSaveInvoice,
} from "../ReviewProvider";

export default function PaymentDetails() {
  const { t } = useTranslation();

  const { invoiceReviewState, refetch, updateBox } = useInvoiceReviewContext();
  const { invoiceData } = invoiceReviewState;
  const { saveInvoice } = useSaveInvoice();
  const [fieldChanged, setFieldChanged] = useState(false);
  const dispatch = useInvoiceReviewStateDispatch();
  const [isPaymentBoxChecked, setIsPaymentBoxChecked] = React.useState(false);

  React.useEffect(() => {
    if (invoiceData) {
      setIsPaymentBoxChecked(invoiceData?.createDatevPayment);
    }
  }, [invoiceData]);

  const handlePaymentDetailsSave = async (
    value: any,
    field: UpdateInvoiceFields,
  ) => {
    await saveInvoice(field, { [field]: value });
    refetch();
  };

  if (!invoiceData?.supplier) return null;

  return (
    <div style={{ marginTop: 20 }}>
      <Grid
        container
        alignItems="center"
        rowSpacing={1}
        columnSpacing={0.8}
        justifyContent="space-between"
      >
        <Grid item xs={3} md={3}>
          <Typography fontWeight={"bold"} variant="body1">
            {t("create_DUO_payment")}
          </Typography>
        </Grid>
        <Grid item xs={9} md={9}>
          <Checkbox
            sx={{ p: 0 }}
            checked={isPaymentBoxChecked}
            onChange={(event) =>
              handlePaymentDetailsSave(
                event.target.checked,
                UpdateInvoiceFields.CreateDatevPayment,
              )
            }
          />
        </Grid>
      </Grid>
    </div>
  );
}
